import React, { useCallback, useEffect, useState } from "react";
import i18n from "utils/i18n";
import ThemedSafeAreaComponentTop from "components/atoms/ThemedSafeAreaTop";
import ThemedLayout from "components/atoms/ThemedLayout";
import { useShowHamburger } from 'utils/helper-device'
import _ from 'lodash'
import FetchTimeslotKinds from 'utils/fetch/FetchTimeslotKinds'
import { useIsFocused, useNavigation, useRoute } from '@react-navigation/native'
import { createTranslationField, retrieveTranslationFields } from 'components/molecules/Form'
import { FormStatus } from 'utils/constants/form-constants';
import LoadingComponent from 'components/atoms/Loading'
import GraphqlBuilder, { graphqlOptions } from 'utils/request/graphql/builder'
import MutateTranslation from 'utils/mutate/translation'
import { constantsActive, tableConstants } from 'utils/constants/constants'
import { AppRoutes } from 'navigations/app-routes'
import MutationManagementTimeslotKind from 'graphql/mutations/management/MutationManagementTimeslotKind'
import HelperString from 'utils/helper-string'
import TabbedContent from 'components/molecules/TabbedContent'
import ManagementTimeslotKindBasicTab from 'scenes/management/timeslots/timeslot_kind/_tabs/Basic'
import ManagementTimeslotKindIconTab from 'scenes/management/timeslots/timeslot_kind/_tabs/Icon'
import ManagementTimeslotKindAdvancedTab from 'scenes/management/timeslots/timeslot_kind/_tabs/Advanced'
import Translate from 'utils/translate'
import { useSelector } from 'react-redux'
import { dataConstants } from 'services/redux/data/constants'
import FetchCachedTimeslotKinds from 'utils/fetch/cached/FetchCachedTimeslotKinds'
import { colorList } from 'utils/colors'
import { timeslotKindConstants } from 'utils/constants/timeslot-kind-constants'
import { IconTimeslotConstants } from 'utils/constants/IconNameConstants'
import ManagementTimeslotKindExceptionTab from 'scenes/management/timeslots/timeslot_kind/_tabs/Exceptions'
import ManagementTimeslotKindLimitationsTab from 'scenes/management/timeslots/timeslot_kind/_tabs/Limitations'

const ManagementTimeslotKindScene = () => {
	const navigation = useNavigation();
	const showHamburger = useShowHamburger();
	const route = useRoute();
	const isFocused = useIsFocused();
	
	const _languages = useSelector( state => {
		return state.data[dataConstants.LANGUAGES];
	} )
	
	const [ isLoading, setIsLoading ] = useState( true );
	const loading = () => {
		setIsLoading(true);
	}
	const loaded = () => {
		setIsLoading(false);
	}
	
	const [ isSaving, setIsSaving ] = useState( false );
	const saving = () => {
		setIsSaving(true);
	}
	const saved = () => {
		setIsSaving(false);
	}
	
	const [ timeslotKind, setTimeslotKind ] = useState( null );
	
	const timeslotKindGuid = _.get( route.params, 'timeslotKindGuid', null );
	
	const fetchedTimeslotKind = ( timeslotKind ) => {
		
		if( _.size( _languages ) > 0 ) {
			// Add the translation fields
			_.forEach( _languages, ( language ) => {
				let { name } = createTranslationField( 'name', language );
				const translation = Translate.formField( timeslotKind, 'title', language );
				if( !_.isEmpty( timeslotKind ) && translation !== null ) {
					timeslotKind[ name ] = translation;
				}
				
				const { name: countName } = createTranslationField( 'count', language );
				const countTranslation = Translate.formField( timeslotKind, 'count', language, 'title' );
				if( !_.isEmpty( timeslotKind ) && countTranslation !== null ) {
					timeslotKind[ countName ] = countTranslation;
				}
				
				const { name: descriptionName } = createTranslationField( 'description', language );
				const descriptionTranslation = Translate.formField( timeslotKind, 'description', language );
				if( !_.isEmpty( timeslotKind ) && descriptionTranslation !== null ) {
					timeslotKind[ descriptionName ] = descriptionTranslation;
				}
			});
		}
		setTimeslotKind( timeslotKind );
		saved();
		loaded();
	}
	
	const fetchTimeslotKind = () => {
		FetchTimeslotKinds.fetch( {
			guid: timeslotKindGuid,
			callbackStart: loading,
			callbackError: loaded,
			callbackSuccess: fetchedTimeslotKind
		});
	}
	
	const updateTimeslotKind = ( values ) => {
		values[ 'translations' ] = retrieveTranslationFields( values );
		setTimeslotKind( {...values} );
	}
	
	const updateTimeslotKindDebounced = useCallback( _.debounce( updateTimeslotKind, 200), []);
	
	const saveForm = ( values, { callback } = {} ) => {
		new GraphqlBuilder( { [ graphqlOptions.processVariables ]: false })
			.addQuery( 'mutation', MutationManagementTimeslotKind, values )
			.setResultPath( ['mutation', 'timeslot_kind'], {} )
			.setOnStart( () => {
				saving();
				callback( FormStatus.LOADING )
			})
			.setOnSuccess( ( result ) => {
				MutateTranslation.mutate( tableConstants.TIMESLOTKINDS, result.guid, values, {
					callbackSuccess: ( t ) => {
						callback( FormStatus.SUCCESS );
						
						FetchCachedTimeslotKinds.reload();
						
						if( _.get( timeslotKind, 'guid' ) !== result.guid ){
							navigation.replace( AppRoutes.MANAGEMENT_TIMESLOT_KINDS, {
								timeslotKindGuid: result.guid,
							});
						}else{
							fetchTimeslotKind();
						}
					},
					callbackError: () => {
						callback( FormStatus.ERROR )
					}
				} )
			})
			.setOnError( ( result ) => {
				saved();
				callback( FormStatus.ERROR )
			})
			.execute()
	}
	
	useEffect( () => {
		if( !_.isEmpty( timeslotKindGuid ) ) {
			fetchTimeslotKind();
		}else{
			let icon = null;
			let kind = _.get( route.params, 'kind', 'custom' );
			let sub_kind = _.get( route.params, 'sub_kind', 'custom_1' );
			
			let backgroundColor = colorList.GREY.primary
			
			switch( kind ){
				case timeslotKindConstants.BOOKING:
					backgroundColor = colorList.ORANGE.primary;
					icon = IconTimeslotConstants.WORKPLACE;
					break;
					
				case timeslotKindConstants.TRANSPORT:
					backgroundColor = colorList.GREEN.primary;
					icon = IconTimeslotConstants.CAR;
					break;
					
				case timeslotKindConstants.LUNCH:
					backgroundColor = colorList.BLUE.primary;
					icon = IconTimeslotConstants.LUNCH;
					break;
					
				case timeslotKindConstants.MEETING_ROOM:
					backgroundColor = colorList.PURPLE.primary;
					icon = IconTimeslotConstants.MEETING_ROOM;
					break;
			}
			
			fetchedTimeslotKind({
				icon: icon,
				icon_color: colorList.WHITE.primary,
				kind: kind,
				sub_kind: sub_kind,
				background_color: backgroundColor,
				show_time: constantsActive.YES,
				can_overlap_with_booking: kind === timeslotKindConstants.BOOKING ? constantsActive.NO : constantsActive.YES,
				can_book_from : 'hour:0:-',
				can_book_until : 'hour:0:-',
				can_cancel_until: 'hour:0:-',
				active: constantsActive.YES
			});
		}
	}, [ isFocused ] );
	
	const tabBarItems = [];
	
	tabBarItems.push({
		key: 'timeslot_kind_basic',
		text: i18n.t('management:form_block.title_default'),
		scene: ( props ) => {
			return (
				<ManagementTimeslotKindBasicTab
					saveForm={ saveForm }
					updateTimeslotKind={ updateTimeslotKindDebounced }
					timeslotKind={ timeslotKind }
					isSaving={ isSaving }
				/>
			);
		}
	});
	
	tabBarItems.push({
		key: 'timeslot_kind_icon',
		text: i18n.t('management:form_block.title_icon'),
		scene: ( props ) => {
			return (
				<ManagementTimeslotKindIconTab
					saveForm={ saveForm }
					updateTimeslotKind={ updateTimeslotKindDebounced }
					timeslotKind={ timeslotKind }
					isSaving={ isSaving }
				/>
			);
		}
	});
	
	tabBarItems.push({
		key: 'timeslot_kind_advances',
		text: i18n.t('management:form_block.title_advanced'),
		scene: ( props ) => {
			return (
				<ManagementTimeslotKindAdvancedTab
					saveForm={ saveForm }
					updateTimeslotKind={ updateTimeslotKindDebounced }
					timeslotKind={ timeslotKind }
					isSaving={ isSaving }
				/>
			);
		}
	});
	
	tabBarItems.push({
		key: 'timeslot_kind_exceptions',
		text: i18n.t('management:form_block.title_exceptions'),
		scene: ( props ) => {
			return (
				<ManagementTimeslotKindExceptionTab
					timeslotKind={ timeslotKind }
				/>
			);
		}
	});
	
	tabBarItems.push({
		key: 'timeslot_kind_limitations',
		text: i18n.t('management:form_block.title_limitations'),
		scene: ( props ) => {
			return (
				<ManagementTimeslotKindLimitationsTab
					timeslotKind={ timeslotKind }
				/>
			);
		}
	});
	
	return (
		<ThemedSafeAreaComponentTop
			top={ false }>
			
			<ThemedLayout
				title={ i18n.t( 'management:pages.timeslots.timeslotKinds.title') }
				topNavigation={true}
				topNavigationProps={{
					showHamburgerDrawer: showHamburger
				}}
				showBackButton={ true }>
				
				<Choose>
					<When condition={ isLoading && !isSaving }>
						<LoadingComponent />
					</When>
					<Otherwise>
						<TabbedContent
							key={ HelperString.hash('profile-tabs' ) }
							items={ tabBarItems }
						/>
					</Otherwise>
				</Choose>
			</ThemedLayout>
		</ThemedSafeAreaComponentTop>
	);
}

export default ManagementTimeslotKindScene
